import { render, staticRenderFns } from "./Communications.vue?vue&type=template&id=1b198105&scoped=true"
import script from "./Communications.vue?vue&type=script&lang=ts"
export * from "./Communications.vue?vue&type=script&lang=ts"
import style0 from "./Communications.vue?vue&type=style&index=0&id=1b198105&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b198105",
  null
  
)

export default component.exports